import { supabase } from './supabaseClient';

export interface IProduct {
  id: string;
  name: string;
  sku: string;
  description?: string;
  price: number | null;
  organization_id: string;
  created_at: string;
  updated_at: string;
}

export class ProductsClient {
  static async getProductsByOrganizationId(
    organization_id: string
  ): Promise<IProduct[]> {
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('organization_id', organization_id);
    if (error) {
      throw error;
    }
    return data;
  }

  static async createProduct(
    product: Omit<IProduct, 'id' | 'created_at' | 'updated_at'>
  ): Promise<IProduct> {
    const { data, error } = await supabase
      .from('products')
      .insert([product])
      .select();
    if (error) {
      throw error;
    }
    return data[0];
  }

  static async updateProduct(
    product: Omit<IProduct, 'created_at' | 'updated_at'>
  ): Promise<IProduct> {
    const { data, error } = await supabase
      .from('products')
      .update(product)
      .eq('id', product.id)
      .select();
    if (error) {
      throw error;
    }
    return data[0];
  }

  static async deleteProduct(id: string): Promise<void> {
    const { error } = await supabase.from('products').delete().eq('id', id);
    if (error) {
      throw error;
    }
  }

  static async getProductsByTag(
    tagKey: string,
    tagValue: string,
    organization_id: string
  ): Promise<IProduct[]> {
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('organization_id', organization_id)
      .contains('tags', [{ key: tagKey, values: [{ value: tagValue }] }]);
    if (error) {
      throw error;
    }
    return data;
  }
}
